import * as React from 'react';
import { connect } from 'react-redux';
import injectSheet from 'react-jss';
import { Select, Button, Checkbox, Input } from 'antd';
import { getPlantDimensions } from 'src/selectors/importsFilter';
import { getPorts } from 'src/api/containerTracking';
import { withRouter } from 'react-router';
import SearchTagsInput from 'src/components/common/SearchTagsInput';
import {
  setFilters,
} from 'src/actions/InquiryFFAction';
import { bindActionCreators } from 'redux';
import { searchCountry } from 'src/api/country';
import { getInternalReferenceNumberList, getLinkedShippers } from 'src/api/inquiry';
import { fetchAddresses } from 'src/api/organisationProfiling';
import { getPolPodTypesInquiryFilter } from '../InquiryUtils';
import { tokens } from 'src/design-system';

const Option = Select.Option;

const styles = theme => ({
  mainDiv: {
    background: 'white',
    position: 'absolute',
    zIndex: 11,
    marginTop: '-11px',
    width: '100%',
    padding: 16,
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid #D9D9D9',
    boxShadow: '2px 2px 2px 0 rgba(0, 0, 0, 0.08)',
    '& .ant-calendar-picker-input': {
      padding: 0,
    },

  },
  childDiv: {
    alignItems: 'center',
    display: 'flex',
    marginBottom: 16,

    '& .ant-checkbox-group-item': {
      minWidth: 80,
    },
  },
  leftElement: {
    width: '170px',
    marginRight: '16px',
  },
  rightElement: {
    margin: '0px 24px',
    fontWeight: tokens.fontWeight.semibold,
  },
  selectStyle: {
    minWidth: '200px',
  },
});
class InquiryFilterPopup extends React.PureComponent<any, any> {
  state = {
    podDropdown: [],
    plantIds: [],
    isSearching: true,
    polDropdown: [],
    createData: {
      originPortIds: [],
      originPortNames: [],
    },
    sourceShippers: [],
    internalReferenceNumber: [],
    uniqueOriginCities: [] as {key: string, label: string}[],
    uniqueDestinationCities: [] as {key: string, label: string}[]
  };

  componentDidMount() {
    this.fetchConsignerAddress();
  }

  fetchConsignerAddress = async () => {
    const response = await fetchAddresses();
    if (response.isSuccess) {
      const addressesList = response.data || [];
      const originCities = {};
      const destinationCities = {};
      addressesList.forEach((address) => {
        if (address.city) {
          if (address.addressTypes?.includes('STUFFING')) {
            originCities[address.city] = {key: address.city, label: `${address.city} [${address.countryCode || '-'}]`};
          } 
          if (address.addressTypes?.includes('DESTUFFING')) {
            destinationCities[address.city] = {key: address.city, label: `${address.city} [${address.countryCode || '-'}]`};
          }
        }
      });
      this.setState({
        uniqueOriginCities : Object.values(originCities),
        uniqueDestinationCities: Object.values(destinationCities)
      });
    }
  }

  searchForSourcePort = async (queryString: string, portType: string) => {
    const response = await getPorts({
      queryString,
      type: 'ALL',
    });
    if (response.isSuccess) {
      this.setState({
        [portType]: response.data.map(el => ({
          key: el.code,
          label: el.name.concat('[', `${el.code}`, ']'),
        })),
      });
    } else {
      this.setState({
        [portType]: [],
      });
    }
  }

  searchConsignerAddress = (query: string, stateKey: string) => {
    if (stateKey === 'polDropdown') {
      this.setState({
        [stateKey]: this.state.uniqueOriginCities.filter(city => city?.label.toLowerCase().includes(query?.toLowerCase())),
      });
    } else if (stateKey === 'podDropdown') {
      this.setState({
        [stateKey]: this.state.uniqueDestinationCities.filter(city => city?.label.toLowerCase().includes(query?.toLowerCase())),
      });
    }
  }

  handleSearch = (type: string, query: string, portType: string) => {
    if (type === 'port') {
      this.searchForSourcePort(query, portType);
    } else if (type === 'city') {
      this.searchConsignerAddress(query, portType);
    } else {
      this.searchForSourceCountry(query, portType);
    }
  }

  searchForSourceCountry = async (queryString: string, portType: string) => {
    const response = await searchCountry({ queryString });
    if (response.isSuccess) {
      this.setState({
        [portType]: response.data.map(country => ({
          key: country.countryCode,
          label: country.countryName,
        })),
      });
    } else {
      this.setState({
        [portType]: [],
      });
    }
  }

  searchShipper = async (queryString: string) => {
    const response = await getLinkedShippers({ queryString });
    if (response.isSuccess) {
      this.setState({
        sourceShippers: response.data.map(shipper => ({
          key: shipper.id,
          label: shipper.name,
        })),
      });
    }
  }

  searchInternalReferenceNumber = async (inquiryString: string) => {
    const response = await getInternalReferenceNumberList({ inquiryString, type: 'FF' });
    if (response.isSuccess) {
      this.setState({
        internalReferenceNumber: response.data.map(item => ({
          key: item.internalReferenceNumber,
          label: item.internalReferenceNumber,
        })),
      });
    }
  }

  handleOriginDestinationSetFilter = (searchFilterTypeValue, value, filterType: 'pol' | 'pod') => {
    if (filterType === 'pol') {
      this.props.setFilters({
        polList: searchFilterTypeValue === 'port' ? value : [],
        originCityList: searchFilterTypeValue === 'city' ? value : [],
        originCountryList: searchFilterTypeValue === 'country' ? value : [],
      });
    } else {
      this.props.setFilters({
        podList: searchFilterTypeValue === 'port' ? value : [],
        destinationCityList: searchFilterTypeValue === 'city' ? value : [],
        destinationCountryList: searchFilterTypeValue === 'country' ? value : [],
      });
    
    }
  }

  renderOriginDestinationFilter = (filterType: 'pol' | 'pod') => {
    const { podDropdown, polDropdown} = this.state;
    
    const {
      originCountryList,
      destinationCountryList,
      polList,
      podList,
      podSearch,
      polSearch,
      originCityList,
      destinationCityList,
    } = this.props.filters;
    
    let polValue = polList;
    let podValue = podList;
    
    if (polSearch === 'city') { 
      polValue = originCityList
    } else if (polSearch === 'country') {
      polValue = originCountryList
    }
    
    if (podSearch === 'city') { 
      podValue = destinationCityList
    } else if (podSearch === 'country') {
      podValue = destinationCountryList
    }
    let dropdownType = filterType === 'pol' ? 'polDropdown' : 'podDropdown';
    let searchFilterKey = filterType === 'pol' ? 'polSearch' : 'podSearch';
    let searchFilterInputValue = filterType === 'pol' ? polValue : podValue;
    let searchFilterTypeValue = filterType === 'pol' ? polSearch : podSearch;
    let dropdownOptions = filterType === 'pol' ? polDropdown : podDropdown;
    
    return (
      <Input.Group compact style={{ minWidth: '31%', maxWidth: '60%' }}>
        <Select
          value={searchFilterTypeValue}
          style={{ width: '15%' }}
          onChange={(type) => this.props.setFilters({ [searchFilterKey]: type })}
        >
          {getPolPodTypesInquiryFilter.map(({ key, label }) => {
            if (key !== 'city') {
              return (
                <Option value={key} key={key} data-testid={`${filterType}${label}`}>
                  {label}
                </Option>
              );
            }
            return null;
          })}
        </Select>
        <SearchTagsInput
          mode="multiple"
          placeholder={`Search & Select ${searchFilterTypeValue}`}
          style={{ minWidth: '40%' }}
          dropdownStyle={{ maxWidth: '240px' }}
          options={dropdownOptions}
          value={searchFilterInputValue}
          onChange={(value) =>
            this.handleOriginDestinationSetFilter(searchFilterTypeValue, value, filterType)
          }
          searchFunction={(e) => this.handleSearch(searchFilterTypeValue, e, dropdownType)}
          size={'default'}
        />
      </Input.Group>
    );
  }

  render() {
    const {
      classes,
      filters,
      setFilters,
      loading,
      handleApply,
      handleCancel,
    } = this.props;

    const {
      sourceShippers,
      internalReferenceNumber,
    } = this.state;

    const options = [
      { label: 'Import', value: 'IMPORT' },
      { label: 'Export', value: 'EXPORT' },
    ];

    return (
      <div className={classes.mainDiv} >
        <div>
          <div className={classes.childDiv}>
            <span className={classes.leftElement}>Origin</span>
            {this.renderOriginDestinationFilter('pol')}
          </div>

          <div className={classes.childDiv}>
            <span className={classes.leftElement}>Destination</span>
            {this.renderOriginDestinationFilter('pod')}
          </div>
          <div className={classes.childDiv}>
            <span className={classes.leftElement}>Shipper </span>
            <SearchTagsInput mode="multiple" placeholder="Select Shipper"
             style={{ minWidth: '30%', maxWidth:'60%' }}
              options={sourceShippers}
              value={filters.shipperList}
              onChange={(selectedFilters) => {
                setFilters({
                  shipperList: selectedFilters,
                });
              }}
              searchFunction={e => this.searchShipper(e)}
              size={'default'} />
          </div>

          <div className={classes.childDiv}>
            <span className={classes.leftElement}>
              Internal Reference #
            </span>
            <SearchTagsInput
              mode="multiple"
              placeholder="Internal Reference #"
              style={{ minWidth: '30%', maxWidth:'60%' }}
              options={internalReferenceNumber}
              value={filters.internalReferenceNumberList}
              onChange={(internalList) => {
                setFilters({
                  internalReferenceNumberList: internalList,
                });
              }}
              searchFunction={e => this.searchInternalReferenceNumber(e)}
              size={'default'} />
          </div>

          <div className={classes.childDiv}>
            <span className={classes.leftElement}>Type</span>
            <Checkbox.Group options={options}
              value={filters.typeList}
              onChange={(checkedValues) => {
                setFilters({
                  typeList: checkedValues,
                });
              }} />
          </div>
        </div>
        <div style={{ display: 'flex', marginLeft:'174px' }}>
          <Button
          disabled={loading}
            style={{
              width: 120, margin: '10px', backgroundColor: '#2A9FD8',
              border: '1px solid #2A9FD8',
            }} onClick={() => handleApply()}
            type="primary">Apply</Button>
          <Button
            style={{ width: 120, margin: '10px' }}
            onClick={() => handleCancel()}
          >Cancel</Button>
        </div>
      </div>
    );
  }
}

const FilterPopupStyled = injectSheet(styles)(InquiryFilterPopup);

const mapStateToProps = ({ masterData, inquiryFFReducer }, ownProps) => ({
  getPlants: getPlantDimensions(masterData),
  filters: inquiryFFReducer.selectedFilters,
  appliedFilters: inquiryFFReducer.appliedFilters,
  plantToLoadingPortsMap: masterData.plantToLoadingPortsMap,
});

const mapDispatchToProps = dispatch => (bindActionCreators({
  setFilters,
}, dispatch));
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FilterPopupStyled));
